import { alertActions }  from '../../store/actions'
import {regConstants} from "../../store/constants"

export const validCompanyInfo = {
  checkFindInput,
}

/***************
 입력정보 체크
 ***************/

function checkFindInput(params) {

  return dispatch => {

    if (params.hasOwnProperty("groupName")) {
      if (!params.groupName || params.groupName?.length <= 0) {
        dispatch(alertActions.error({
          title: "사업자/단체명",
          message: "사업자/단체명을 입력해주세요."
        }))
        return false
      }
    }

    if (params.hasOwnProperty("rprsntvNm")) {
      if (!params.rprsntvNm || params.rprsntvNm?.length <= 0) {
        dispatch(alertActions.error({
          title: "대표자명",
          message: "대표자명을 입력해주세요."
        }))
        return false
      }
    }

  

    

    

    return true
  }
}
